import { render, staticRenderFns } from "./carStructureList.vue?vue&type=template&id=d11447b2&scoped=true"
import script from "./carStructureList.vue?vue&type=script&lang=js"
export * from "./carStructureList.vue?vue&type=script&lang=js"
import style0 from "./carStructureList.vue?vue&type=style&index=0&id=d11447b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d11447b2",
  null
  
)

export default component.exports